<script setup>
import GroupedActionPanel from "@/components/actions/partials/GroupedActionPanel.vue";
import HidePageActions from "@/components/actions/buttons/HidePageActions.vue";
import ActionRow from "@/components/actions/partials/ActionRow.vue";
import ActionTime from "@/components/actions/partials/ActionTime.vue";
import CompletePageActions from "@/components/actions/buttons/CompletePageActions.vue";
import {useQuery} from "@tanstack/vue-query";
import axios from "axios";
import {computed} from "vue";
import GroupedActionPanelTitle from "@/components/actions/partials/GroupedActionPanelTitle.vue";

const props = defineProps({
  pageId: {
    type: Number,
    required: true,
  },
});

const {data: actions} = useQuery({
  queryKey: ['actions', props.pageId],
  queryFn: async () => {
    const response = await axios.get(`/ajax/v2/actions/page/${props.pageId}`);

    return response.data.data;
  },
})

const page = computed(() => {
  return actions.value?.[0]?.page
})

const totalTime = computed(() => {
  return actions.value?.reduce((a, b) => a + (b.action_time ?? 0), 0)
})

</script>

<template>
  <div class="tailwind">
    <GroupedActionPanel v-if="page">
      <template #title>
        <GroupedActionPanelTitle
          :title="page.url"
          url
        />
      </template>

      <template #action-time>
        <ActionTime
          :minutes="totalTime"
          class="tw-font-semibold"
        />
      </template>

      <template #toolbar>
        <div class="tw-flex tw-gap-2">
          <CompletePageActions :page-id="pageId" />
          <HidePageActions :page-id="pageId" />
        </div>
      </template>

      <template #actions>
        <ActionRow
          v-for="action in actions"
          :key="action.id"
          :action="action"
        />
      </template>
    </GroupedActionPanel>
  </div>
</template>
